export default __webpack_public_path__ + "static/media/infoIcon.89f7bf33.svg";